module.exports = __webpack_public_path__ + "img/missing.cb5f497a.jpg";